import { window } from '../../../helpers/BrowserHelpers';
import BlockTypes from '../../../types/BlockTypes';
export default function makeOnChange(store) {
  var previousSelectedTableCell;
  return {
    onChange: function onChange(editor, next) {
      var selectionChanged = store.getItem('selection') !== editor.value.selection;
      var tableSelected = !!store.getItem('lastFocusedTableId');

      if (editor.value.selection.isSet && selectionChanged && tableSelected) {
        // Selection has changed, following a user intent
        editor.deselectTable();
      } else if (tableSelected) {
        // Value and cell keys have changed
        editor.refreshSelectedCellKeys();
      }

      if (editor.value.selection.isSet && editor.value.selection.isCollapsed && editor.value.startBlock.type === BlockTypes.TABLE_CELL && editor.value.startBlock !== previousSelectedTableCell) {
        previousSelectedTableCell = editor.value.startBlock;
        setTimeout(function () {
          var path = editor.value.document.getPath(previousSelectedTableCell.key); // eslint-disable-next-line react/no-find-dom-node

          var element = editor.findDOMNode(path, window);

          if (element && typeof element.scrollIntoViewIfNeeded === 'function') {
            element.scrollIntoViewIfNeeded();
          }
        });
      }

      return next();
    }
  };
}